// extracted by mini-css-extract-plugin
export var dataCell = "_r4-2";
export var dataRow = "_r4-0";
export var headerRow = "_r4-1";